import {Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {DbActiveModal} from "../../../../modules/modal/modal-ref";
import * as fromStore from "../../../../store";
import {Store} from "@ngrx/store";
import {first, takeUntil} from "rxjs/operators";
import {UserSubscriptionType} from "../../../../user/user-subscription";
import {TypeUtils} from "../../../utils/type-utils";
import {Subject} from "rxjs";

const IMAGE_OPTIMIZER = [
  'Advanced image optimization',
  'Up to 50K images optimization per month',
  'Multiple optimization modes',
];

const IMAGE_OPTIMIZER_PRO = [
  'Advanced image optimization',
  'Optimization of unlimited images',
  'Multiple optimization modes',
];

const BOOSTER = [
  'Full frontend optimization of 6 pages',
  '90+ PageSpeed score',
  'Improved Core Web Vitals',
  'Custom optimization rules',
  'Website caching',
  'CSS, HTML & JS minification and compression',
];

const BOOSTER_PRO = [
  'Full frontend optimization of entire website',
  '90+ PageSpeed score',
  'Improved Core Web Vitals',
  'Custom optimization rules',
  'Website caching',
  'CSS, HTML & JS minification and compression',
];

@Component({
    selector: 'db-booster-free-plan-intro',
    templateUrl: './booster-free-plan-intro.component.html',
    styleUrls: ['./booster-free-plan-intro.component.scss'],
    standalone: false
})
export class BoosterFreePlanIntroComponent implements OnInit {
  @Input() websiteId: number;
  imageOptimizer = IMAGE_OPTIMIZER;
  booster = BOOSTER;
  subscriptionTitle = '';
  isPaid = false;
  boosterIsActive = false;
  websiteUrl: string;

  private readonly _destroyStream$ = new Subject<boolean>();

  constructor(
    private readonly router: Router,
    private readonly activeModal: DbActiveModal,
    private readonly _store: Store<fromStore.DbStoreState>,
  ) {
  }

  ngOnInit() {
    this._addEventHandlers();
    this.getSubscription();
  }

  private _addEventHandlers(): void {
    this._getWebsite();
    this._checkBoosterState();
  }

  private getSubscription(): void {
    this._store.select(fromStore.getUserSubscription)
      .pipe(
        first(userSubscription => !!userSubscription)
      )
      .subscribe(userSubscription => {
        this.subscriptionTitle = userSubscription.subscriptionTitleName;
        this.isPaid = userSubscription.type !== UserSubscriptionType.FREE;
        if (this.isPaid) {
          this.imageOptimizer = IMAGE_OPTIMIZER_PRO;
          this.booster = BOOSTER_PRO;
        }
      });
  }

  private _checkBoosterState(): void {
    this._store.select(fromStore.getWebsiteOptimizerPlugin(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe((optimizerPlugin): void => {
        if (optimizerPlugin && !TypeUtils.isEmpty(optimizerPlugin)) {
          this.boosterIsActive = optimizerPlugin.active;
        }
      });
  }

  private _getWebsite(): void {
    this._store.select(fromStore.getWebsite(this.websiteId))
      .pipe(
        first(website => !!website, null)
      )
      .subscribe(website => {
        this.websiteUrl = website && website.site_url.replace(/^https?:\/\//i, '');
      });
  }

  redirectToWebsite(): void {
    this.router.navigate([`/websites/${this.websiteId}/booster/image-optimizer`]).then(() => this.activeModal.close());
  }
}
